import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';
import SupportStatusLabel from 'components/importer/support_status_label';

export default function ImportRequestsRow({ importRequest }) {
  const goToImportRequest = (event) => {
    clickAsLink(window, importRequest.importerImportRequestPath, event);
  };

  return (
    <tr className="clickable-row" onClick={goToImportRequest}>
      <td>{importRequest.requestedBy}</td>
      <td>{importRequest.dateSupportRequested}</td>
      <td><SupportStatusLabel supportStatus={importRequest.supportStatus} /></td>
      <td>{importRequest.clientNotes}</td>
    </tr>
  );
}

ImportRequestsRow.propTypes = {
  importRequest: PropTypes.shape({
    clientNotes: PropTypes.string,
    dateSupportRequested: PropTypes.string,
    importerImportRequestPath: PropTypes.string,
    supportStatus: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    }),
    requestedBy: PropTypes.string
  }).isRequired
};
